module.exports = __webpack_public_path__ + "img/多领域服务2.a46f3d42.jpg";